// extracted by mini-css-extract-plugin
export default {"containerWidth":"oDjzdfhQMEE3kwsairPY"};